export const GA_MEASUREMENT_ID: string = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '';
export const NEXT_PUBLIC_GA4_ID: string = process.env.NEXT_PUBLIC_GA4_ID || '';

declare global {
  interface Window {
    gtag?: (key: string, ...args: any[]) => void;
  }
}

export const pageview = (url: string, title: string): void => {
  const homeTitle = 'Real-Time Analytics for a User-Facing World | StarTree';

  if (window.gtag && (url !== '/' || (url === '/' && title === homeTitle))) {
    window.gtag('config', 'GTM-KFDQTC4', {
      page_path: url,
      page_title: title,
    });
  }
};

interface EventProps {
  action: string;
  category: string;
  label?: string;
  value?: number;
}

export const event = ({ action, category, label, value }: EventProps): void => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};
